import type { SiteConfig } from '@/types/config';

declare const __SITE_CONFIG__: SiteConfig;
const siteConfig = __SITE_CONFIG__;
export default siteConfig; 

// export const getIsServiceEnabled = (service: SiteConfigService) =>
//   siteConfig.services.includes(service);

